import WTF from './wtf';

export {WTF};
